module.exports = __webpack_public_path__ + "static/media/OB.caa84202.jpg";